import { lazy } from "react";

export {
  PROJECTS_PATH,
  PROJECT_SEARCH_PARAM,
  TASK_SEARCH_PARAM,
  projectUrl,
} from "./path";
export const Projects = lazy(() => import("./page"));
